import { render, staticRenderFns } from "./filesTable.vue?vue&type=template&id=49696120&scoped=true&"
import script from "./filesTable.vue?vue&type=script&lang=js&"
export * from "./filesTable.vue?vue&type=script&lang=js&"
import style0 from "./filesTable.vue?vue&type=style&index=0&id=49696120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49696120",
  null
  
)

export default component.exports